<template>

<app-page :title="title" back="Patients">

    <app-panel title="Patient" :is-padded="true">

        <app-input type="text" label="First name" placeholder="Enter first name" v-model="model.firstname" />
        <app-input type="text" label="Last name" placeholder="Enter last name" v-model="model.lastname" />
        <app-input type="text" label="E-mail address (optional)" placeholder="Enter e-mail address" v-model="model.email" />
        <app-input type="text" label="Date of birth (optional)" placeholder="Enter date of birth (DD/MM/YYYY)" v-model="model.dob" />

    </app-panel>

    <app-actions>

        <app-button text="Save" :is-disabled="!canSave || !validDate" :is-loading="is.saving" v-on:click.native="onSaveClick" />
        <app-button text="Delete" v-if="canDelete" :is-loading="is.deleting" theme="red" v-on:click.native="onDeleteClick" />

    </app-actions>

    <app-panel title="Record" :is-padded="true" v-if="!isNew">

        <app-input type="text" label="Reference" :is-locked="true" :can-copy="true" v-model="model.reference" />
        <app-input type="text" label="Code" :is-locked="true" :can-copy="true" v-model="model.code" />

    </app-panel>

    <app-actions v-if="model.email">

        <app-button text="E-mail code" v-if="!isNew" theme="grey" :is-loading="is.sending" v-on:click.native="onSendClick" />

    </app-actions>

</app-page>

</template>

<script>

import mixForm from '@/mixin/form'
import { required, email } from 'vuelidate/lib/validators'
import validateDate from 'validate-date'

export default {

    mixins: [mixForm],

    data: function() {

        return {
            api: 'patients',
            is: {
                sending: false
            },
            redirect: {
                new: 'Patients',
                delete: 'Patients'
            }
        }

    },

    validations: function() {

        var validations = {
            model: {
                firstname: { 
                    required 
                },
                lastname: { 
                    required 
                },
                email: { 
                    email
                }
            }
        }

        return validations

    },

    computed: {

        validDate: function() {
        
            return (this.model.dob) ? validateDate(this.model.dob, 'boolean', 'dd/mm/yyyy') : true

        },
    
        title: function() {

            return (this.isNew) ? 'Add Patient' : 'Edit Patient'
        
        }
    
    },

    methods: {
    
        onSendClick: function() {

            if(this.is.sending) return false

            this.is.sending = true
        
            this.$api.post(['patients', this.model.id, 'send']).then(function() {

                this.$success('E-mail sent successfully')
            
                this.is.sending = false
            
            }.bind(this))
        
        }
    
    }

}

</script>

<style scoped>

</style>
